/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Locations/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Locations({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/Locations"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedLocationsValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'locations',
format: fromFormat.getSelectedLocationsView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(selectedLocationsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}